// =============================================================================
// Norvyn cart engine — final architecture (2026-07-19)
// Ported from the Eziro god-man engine (v5 config-driven), then evolved live.
// =============================================================================
//
// WHAT THIS FILE DOES (loaded from sections/cart-drawer.liquid on every page):
//   1. TIER STEPPING - drawer/cart +/- moves between bundle tiers, never unit
//      by unit. Ladder: Buy N paid -> gifts at the Buy3Get2 ratio.
//      Totals: 1 / 3 / 5 / 6 / 8 / 10 / 11 / 13 / 15 (Buy 1 .. Buy 9, capped).
//      Matching automatic BxGy discounts exist per rung (B2G1, B3G2, B5G3,
//      B7G4, B8G5, B9G6 active; B4G3/B5G4/B6G5 retired: a discount that does
//      not consume its rung total EXACTLY leaves a leftover third line).
//   2. DISPLAY MERGE - Shopify's pick between equal-value discounts (e.g.
//      total 6: B2G1x2 vs B3G2) is nondeterministic and can fragment the mat
//      into multiple paid lines. mergeMainRowsInDom() always presents ONE paid
//      row (summed qty/price/savings) + the free allocation row. All DOM
//      writes are idempotent (signature gate + stamp-once per-unit price):
//      a MutationObserver-driven rewriter that is not idempotent re-triggers
//      itself and compounds - that caused the $5.4e19 old-price incident.
//   3. REBUILD - illegal totals (external drift) are rebuilt once to the
//      nearest legal tier: zero mat lines via /cart/change (which honors
//      split-line keys; /cart/update silently ignores them), then re-add.
//      Never triggered at legal totals, so it cannot loop.
//   4. SHIPPING PROTECTION - auto-added once after a mat ATC; toggle-off is
//      remembered (sessionStorage opt-out) incl. FormData add detection.
//   5. TRASH - removing the mat cascades SP removal, all variant-keyed.
//
// INTEGRATION POINTS: snippets/cart-items.liquid + sections/main-cart-items
// .liquid rows carry data-line-key / data-variant-id; assets/cart.js posts
// {id: lineKey} instead of {line} (index bodies corrupt after re-renders).
//
// KNOWN COSMETICS (accepted): the discount TAG shows the mechanic name (e.g.
// "BUY 3 GET 2 FREE" while sitting on the Buy-4 tier); free-row gift badge
// counts only its own line if the free allocation ever splits.
//
// QA: sim_test5.js (12 logic cases) + sim_test6.js (DOM idempotency storm) +
// harness.html (real Chrome against the deployed minified build) - all green
// 2026-07-19. Keep them green when touching this file.
// =============================================================================

(function () {
  // Use a configurable install marker (allows multi-product co-existence if needed)
  // Default name preserved for backward compat with existing tests/integrations.
  var INSTALL_KEY = (typeof window.__norvynInstallKey === "string") ? window.__norvynInstallKey : "__norvynCartLogicInstalled";
  if (window[INSTALL_KEY]) return;
  window[INSTALL_KEY] = true;

  // ===========================================================================
  // 0. BUNDLE_CONFIG — single source of truth (EDIT THIS FOR NEW PRODUCTS)
  // ===========================================================================

  // 2026-09-05 copper relaunch (store wx0mnz-zp). The cooling-mat entry below is the
  // old product and does not exist on this store; leaving it as the fallback made
  // MAIN_VARIANT point at a variant that is never in the cart, so maybeAddSP() always
  // bailed AND reconcileMain() deleted Shipping Protection on every cleanup pass.
  // 2026-09-10: the copper cuff moved from fixed-amount quantity discounts to real
  // BxGy discounts (B2G1 consumes 3 exactly, B3G2 consumes 5 exactly), so Shopify now
  // emits a paid line plus a $0.00 free line and the cart shows the gift separately.
  // bxgyMerge is therefore ON for the cuff: at totals that are not a clean multiple of
  // a rung (qty 4 splits 1 + 1free + 2) the paid rows are merged into one visual row.
  // linearTiers stays ON: our ladder is 1 / 3 / 5 and any quantity is legal, so drawer
  // +/- must keep stepping one unit at a time and must never snap or rebuild.
  // The ankle sleeves still use plain quantity pricing, so their bxgyMerge stays off. variants lists every live
  // variant so "the cart holds a real product" is true on any page and for any size.
  var NORVYN_LIVE_VARIANTS = [
    "55434667163967",                                                        // copper-cuff
    "55434667688255", "55434667721023", "55434667753791", "55434667786559",  // ankle-sleeves S/M/L/XL
    "55657698165055",                                                                     // pickleball-at-home-kit, Kit Only
    "55694331183423"                                                                      // pickleball-at-home-kit, Kit + Paddle (2026-09-22)
    , "67580497494335"                                                                    // back-relief-massager (2026-09-25)
    , "67580497625407", "67580497658175", "67580497690943"                                // back relief cart add-ons: support belt, red light belt, patches 24-pack (2026-09-25)
  ];

  var NORVYN_PRODUCT_CONFIGS = {
    // 2026-10-10: the old cooling-mat entry (product from the 2026-07 store) was removed; that product is gone from this store.
    "10612911374655": { mainVariant: "55434667163967", mainProductId: "10612911374655", handle: "copper-cuff",
                        variants: NORVYN_LIVE_VARIANTS, tierVariants: ["55434667163967"], bxgyMerge: true },
    // copper-cuff 2026-09-10 (Eric): full Buy3Get2-ratio ladder like the mat, capped at
    // Buy 9. No linearTiers and no tierTotals, so the default qFromN applies:
    // totals 1/3/5/6/8/10/11/13/15. Drawer +/- steps paid 1->2->3..., gifts 0->1->2->2->3->4->4->5->6.
    // Discount rungs live on the store: B2G1, B3G2, B5G3, B7G4, B8G5, B9G6 (each consumes its
    // rung exactly; rung 6 = B2G1 x2, rung 10 = B3G2 x2).
    "10612911669567": { mainVariant: "55434667688255", mainProductId: "10612911669567", handle: "ankle-sleeves",
                        variants: NORVYN_LIVE_VARIANTS, linearTiers: true, bxgyMerge: false },
    // 2026-09-18 pickleball-at-home-kit: plain quantity pricing ($39.99 each, no tiers, no free
    // units). linearTiers keeps drawer +/- at one unit per step with no snap or rebuild, and
    // tierVariants limits the stepper interception to this kit, so a copper-cuff tier line in the
    // same cart is never counted as a kit fragment (the 2026-09-10 cross-product bug).
    "10640140042559": { mainVariant: "55657698165055", mainProductId: "10640140042559", handle: "pickleball-at-home-kit",
                        variants: NORVYN_LIVE_VARIANTS, tierVariants: ["55657698165055"], linearTiers: true, bxgyMerge: false }
  };

  var NORVYN_HANDLE_TO_PRODUCT_ID = (function () {
    var out = {};
    Object.keys(NORVYN_PRODUCT_CONFIGS).forEach(function (pid) {
      out[NORVYN_PRODUCT_CONFIGS[pid].handle] = pid;
    });
    return out;
  })();

  function resolveNorvynProduct() {
    var injected = window.__norvynProduct || null;
    var injectedId = injected && (injected.mainProductId || injected.productId || injected.id);
    if (injectedId && NORVYN_PRODUCT_CONFIGS[String(injectedId)]) {
      return NORVYN_PRODUCT_CONFIGS[String(injectedId)];
    }

    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (meta && NORVYN_PRODUCT_CONFIGS[String(meta.id)]) {
      return NORVYN_PRODUCT_CONFIGS[String(meta.id)];
    }
    if (meta && meta.variants && meta.variants[0]) {
      var metaVariant = String(meta.variants[0].id);
      var byVariant = Object.keys(NORVYN_PRODUCT_CONFIGS).filter(function (pid) {
        return NORVYN_PRODUCT_CONFIGS[pid].mainVariant === metaVariant;
      });
      if (byVariant.length) return NORVYN_PRODUCT_CONFIGS[byVariant[0]];
    }

    var match = (window.location.pathname || "").match(/\/products\/([^/?#]+)/);
    if (match) {
      var handle = "";
      try { handle = decodeURIComponent(match[1]); } catch (_) { handle = match[1]; }
      if (NORVYN_HANDLE_TO_PRODUCT_ID[handle]) {
        return NORVYN_PRODUCT_CONFIGS[NORVYN_HANDLE_TO_PRODUCT_ID[handle]];
      }
    }

    // Off-product pages (home, cart, collections): fall back to the live copper-cuff
    // config, which carries every live variant, so the cart invariants hold everywhere.
    return NORVYN_PRODUCT_CONFIGS["10612911374655"];
  }

  var PAGE_BUNDLE_PRODUCT = resolveNorvynProduct();

  var BUNDLE_CONFIG = {

    // ---- Identity ----------------------------------------------------------
    mainVariant:    PAGE_BUNDLE_PRODUCT.mainVariant,      // numeric variant ID (the bundle main product)
    mainProductId:  PAGE_BUNDLE_PRODUCT.mainProductId,    // numeric product ID
    spVariant:      String(window.GM_SHIPPING_PROTECTION_VARIANT_ID || "55432728314175"),      // shipping-protection variant (or null)
    spOptedOutKey:  "nv_sp_opted_out",     // sessionStorage key for SP opt-out
    logTag:         "[norvyn]",           // console.log prefix

    // ---- N -> Q math -------------------------------------------------------
    // For god-man: Tier 2 (Buy 2 Get 1 Free) + Tier 3 (Buy 3 Get 2 Free) stacking.
    // Replace this function for different bundle shapes.
    qFromN: function (N) {
      // Gift ladder (2026-07-19 FINAL v2, per Eric): gifts scale at the Buy3Get2
      // ratio - Buy1=+0, Buy2=+1, Buy3=+2, Buy4=+2, Buy5=+3, Buy6=+4.
      // Totals: 1 / 3 / 5 / 6 / 8 / 10. Discount set chosen so each rung is
      // consumed EXACTLY by its discount (=> Shopify renders a clean 2-line
      // paid+free split, never a third leftover line): rung 3 = B2G1, rung 5 =
      // B3G2, rung 6 = B2G1 x2, rung 8 = B5G3, rung 10 = B3G2 x2.
      // B4G3/B5G4/B6G5 deactivated (partial consumption -> 3-line displays).
      // Capped at N=9 (rungs B7G4/B8G5/B9G6 cover 11/13/15).
      N = Math.max(0, parseInt(N, 10) || 0);
      // 2026-09-10: products with an explicit tierTotals ladder use only those totals.
      // The copper cuff sells Buy 1 / Buy 2 Get 1 Free / Buy 3 Get 2 Free, so the only
      // legal cart totals are 1, 3 and 5. Without this the drawer +/- stepped one unit
      // at a time and exposed totals 2, 4 and 6, where the shopper pays the same as the
      // tier above but receives fewer cuffs (2 and 3 both cost $146.00, 4 and 5 both
      // cost $219.00). nFromQ floors an illegal total to the tier below, so a drifted
      // cart rebuilds down (2 -> 1, 4 -> 3, 6 -> 5) and never costs the shopper more.
      if (PAGE_BUNDLE_PRODUCT.tierTotals) {
        var TT = PAGE_BUNDLE_PRODUCT.tierTotals;
        if (N === 0) return 0;
        if (N > TT.length) N = TT.length;
        return TT[N - 1];
      }
      // 2026-09-05: linear products (plain quantity tiers, no free units) map N -> N,
      // so nFromQ/qFromN are the identity and nothing ever snaps or rebuilds.
      if (PAGE_BUNDLE_PRODUCT.linearTiers) return N;
      if (N === 0) return 0;
      if (N > 9) N = 9; // rungs B7G4(11)/B8G5(13)/B9G6(15) created 2026-07-19
      if (N === 1) return 1;
      if (N === 2) return 3;
      var q = Math.floor(N / 3), r = N - q * 3;
      if (r === 0) return 5 * q;
      if (r === 1) return 5 * q + 1;
      return 5 * q + 3;
    },

    // ---- Gift tiers --------------------------------------------------------
    // Additive Mode B: tier 2 supplies base gifts + store credit; tier 3 adds physical gifts.
    giftStrategy: "replace",
    giftTiers: [],  // Norvyn: no attached gift products; free units are same-variant via BxGy auto-discounts

    // ---- Tuning (defaults work for most products) --------------------------
    cleanupDebounceMs:   100,    // ms after /cart/* response before cleanup fires
    postAddFallbackMs:   1000,   // safety-net cleanup retry after /cart/add
    verifyGiftsDelayMs:  1500,   // ms after cleanup converges to verify gift invariant
    maxCleanupPasses:    6,      // max multi-pass cleanup iterations
    maxPassRetryMs:      2000,   // ms to wait before retrying after max-pass exit
  };

  // ===========================================================================
  // 1. Derived state + helpers (DO NOT EDIT)
  // ===========================================================================

  var CFG               = BUNDLE_CONFIG;
  var T                 = CFG.logTag;
  var MAIN_VARIANT      = CFG.mainVariant;
  var MAIN_PRODUCT_ID   = CFG.mainProductId;
  // 2026-09-05: every variant that counts as "the main product". A single-variant
  // product keeps the old behaviour exactly, because the list is just [mainVariant].
  var MAIN_VARIANTS     = (PAGE_BUNDLE_PRODUCT.variants && PAGE_BUNDLE_PRODUCT.variants.length)
                            ? PAGE_BUNDLE_PRODUCT.variants.map(String)
                            : [String(CFG.mainVariant)];
  var MERGE_ENABLED     = PAGE_BUNDLE_PRODUCT.bxgyMerge !== false;
  function isMainVariant(id) { return MAIN_VARIANTS.indexOf(String(id)) !== -1; }
  // 2026-09-10: MAIN_VARIANTS used to drive BOTH the tier math and the "does the cart
  // still hold a real product" check. On the cuff page it lists every live variant, so
  // an ankle-sleeve line was counted into the cuff's tier total (3 cuffs + 1 sleeve = 4,
  // illegal) and the rebuild zeroed the sleeve. TIER_VARIANTS is the subset that the
  // tier math (count / snap / rebuild / merge) may touch; MAIN_VARIANTS keeps the wider
  // role so Shipping Protection is only cascaded away when NO live product is left.
  var TIER_VARIANTS     = (PAGE_BUNDLE_PRODUCT.tierVariants && PAGE_BUNDLE_PRODUCT.tierVariants.length)
                            ? PAGE_BUNDLE_PRODUCT.tierVariants.map(String)
                            : MAIN_VARIANTS;
  function isTierVariant(id) { return TIER_VARIANTS.indexOf(String(id)) !== -1; }
  var SP_VARIANT        = CFG.spVariant;
  // 2026-10-10: optional PDP add-on cascade (lines carrying GM_ADDON_PROPERTY leave with the last
  // GM_ADDON_PARENT_VARIANTS line) and the /cart page check the trash override below needs.
  var ADDON_PROP        = window.GM_ADDON_PROPERTY || null;
  var ADDON_PARENTS     = (window.GM_ADDON_PARENT_VARIANTS || []).map(String);
  function onCartPage() { return !!document.getElementById("main-cart-items"); }
  var SP_OPTED_OUT_KEY  = CFG.spOptedOutKey;
  var SCROLL_SEL        = "cart-drawer-items, #CartDrawer-CartItems, .drawer__contents, .js-contents, .drawer__inner";

  // Flat list of all gift variant IDs across all tiers (for membership checks)
  var ALL_GIFT_IDS = (function () {
    var seen = {};
    CFG.giftTiers.forEach(function (t) {
      (t.ids || []).forEach(function (id) { seen[String(id)] = true; });
    });
    return Object.keys(seen);
  })();

  // What gift IDs should be in cart at this N? (handles replace vs additive)
  function giftIdsForN(N) {
    if (CFG.giftStrategy === "additive") {
      var seen = {};
      CFG.giftTiers.forEach(function (t) {
        if (N >= t.minN) (t.ids || []).forEach(function (id) { seen[String(id)] = true; });
      });
      return Object.keys(seen);
    }
    // Default "replace": highest applicable tier wins
    var applicable = CFG.giftTiers
      .filter(function (t) { return N >= t.minN; })
      .sort(function (a, b) { return b.minN - a.minN; });
    return applicable.length === 0 ? [] : applicable[0].ids.slice();
  }

  // ---- Module state --------------------------------------------------------
  var internalMutation     = 0;
  var cleanupTimer         = null;
  var cleanupRunning       = false;
  var cleanupQueuedReason  = null;
  var cachedCart           = null;
  var lastDrawerHash       = null;
  var lastScrollTop        = 0;
  var snapMutex            = Promise.resolve();
  var rebuildTargetQ       = null;
  var origFetch            = window.fetch.bind(window);
  window.__gmOrigFetch     = origFetch;

  // ---- Logging -------------------------------------------------------------
  function log() {
    try { console.log.apply(console, [T].concat([].slice.call(arguments))); } catch (_) {}
  }
  function logErr(label, err) {
    try { log(label, err && (err.message || err)); } catch (_) {}
  }

  // ---- Cart predicates -----------------------------------------------------
  function isLinkedGift(item)      { return ALL_GIFT_IDS.indexOf(String(item.id)) !== -1; }
  function mainLines(cart)         { return ((cart && cart.items) || []).filter(function (i) { return isTierVariant(i.id); }); }
  function liveLines(cart)         { return ((cart && cart.items) || []).filter(function (i) { return isMainVariant(i.id); }); }
  function totalMainQty(cart)      { return mainLines(cart).reduce(function (s, i) { return s + i.quantity; }, 0); }
  function isSpOptedOut()          { try { return sessionStorage.getItem(SP_OPTED_OUT_KEY) === "1"; } catch (_) { return false; } }
  function setSpOptedOut(v) {
    try {
      if (v) sessionStorage.setItem(SP_OPTED_OUT_KEY, "1");
      else   sessionStorage.removeItem(SP_OPTED_OUT_KEY);
    } catch (_) {}
  }

  // ===========================================================================
  // 2. N ↔ Q math wrappers
  // ===========================================================================

  function qFromN(N) { return CFG.qFromN(N); }

  // Reverse Q → N — floors to nearest legal N via forward iteration
  function nFromQ(Q) {
    Q = Math.max(0, parseInt(Q, 10) || 0);
    if (Q === 0) return 0;
    var best = 1;
    for (var n = 1; n <= 200; n++) {
      var q = qFromN(n);
      if (q === Q) return n;
      if (q > Q) return Math.max(1, n - 1);
      best = n;
      if (q === qFromN(n + 1)) return best; // plateau: qFromN is capped, Q above cap maps to top tier
    }
    return best;
  }

  log("v5-config-driven installed @", new Date().toISOString(),
      "main=", MAIN_VARIANT, "mains=", MAIN_VARIANTS.join(","),
      "linear=", !!PAGE_BUNDLE_PRODUCT.linearTiers, "merge=", MERGE_ENABLED,
      "sp=", SP_VARIANT, "giftStrategy=", CFG.giftStrategy,
      "tiers=", CFG.giftTiers.length);

  // ===========================================================================
  // 3. Cart API wrappers
  // ===========================================================================

  async function getCart() {
    var r = await origFetch("/cart.js", { credentials: "same-origin" });
    cachedCart = await r.json();
    return cachedCart;
  }

  async function ensureCartFresh() {
    if (cachedCart) return cachedCart;
    try { return await getCart(); }
    catch (e) { logErr("getCart err", e); }
    return cachedCart;
  }

  async function updateCart(updates) {
    if (!updates || Object.keys(updates).length === 0) return null;
    internalMutation++;
    try {
      var r = await origFetch("/cart/update.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          updates: updates,
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: window.location.pathname
        })
      });
      if (!r.ok) {
        var body = ""; try { body = await r.text(); } catch (_) {}
        log("updateCart FAIL status=", r.status, "body=", body.slice(0, 200));
        return null;
      }
      var d = await r.json();
      cachedCart = (d && d.items) ? d : await getCart();
      refreshDrawer(d.sections);
      refreshBubble(d.sections);
      return d;
    } catch (e) { logErr("updateCart threw", e); return null; }
    finally { internalMutation = Math.max(0, internalMutation - 1); }
  }

  async function addOne(item) {
    internalMutation++;
    try {
      var r = await origFetch("/cart/add.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [item],
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: window.location.pathname
        })
      });
      if (!r.ok) {
        var body = ""; try { body = await r.text(); } catch (_) {}
        log("addOne FAIL id=", item.id, "status=", r.status, "body=", body.slice(0, 200));
        return false;
      }
      return true;
    } catch (e) { logErr("addOne threw", e); return false; }
    finally { internalMutation = Math.max(0, internalMutation - 1); }
  }

  async function addItems(items) {
    if (!items || items.length === 0) return null;

    internalMutation++;
    var batchOk = false, batchData = null;
    try {
      var r = await origFetch("/cart/add.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: items,
          sections: ["cart-drawer", "cart-icon-bubble"],
          sections_url: window.location.pathname
        })
      });
      if (r.ok) {
        batchData = await r.json();
        cachedCart = await getCart();
        refreshDrawer(batchData.sections);
        refreshBubble(batchData.sections);
        batchOk = true;
      } else {
        var body = ""; try { body = await r.text(); } catch (_) {}
        log("addItems batch FAIL status=", r.status, "body=", body.slice(0, 200), "items=", items.length);
      }
    } catch (e) { logErr("addItems batch threw", e); }
    finally { internalMutation = Math.max(0, internalMutation - 1); }

    if (batchOk) return batchData;

    // Per-item fallback retry — one bad item shouldn't block others
    var anySuccess = false;
    for (var i = 0; i < items.length; i++) {
      var ok = await addOne(items[i]);
      if (ok) {
        anySuccess = true;
        log("addItems retry-success", i, "id=", items[i].id);
      }
    }
    if (anySuccess) {
      try { cachedCart = await getCart(); } catch (_) {}
      return { partial: true };
    }
    return null;
  }

  async function maybeAddSP() {
    if (!SP_VARIANT || isSpOptedOut()) return;
    var cart = await getCart();
    if ((cart.items || []).some(function (i) { return String(i.id) === SP_VARIANT; })) return;
    if (!(cart.items || []).some(function (i) { return isMainVariant(i.id); })) return;
    log("auto-adding SP");
    await addItems([{ id: parseInt(SP_VARIANT, 10), quantity: 1 }]);
  }

  // ===========================================================================
  // 4. Drawer refresh (preserves outer class + scrollTop)
  // ===========================================================================

  function refreshDrawer(sections) {
    if (!sections || !sections["cart-drawer"]) return;
    try {
      var html = sections["cart-drawer"];
      var hash = html.length + ":" + html.charCodeAt(0) + ":" +
                 html.charCodeAt(html.length >> 1) + ":" + html.charCodeAt(html.length - 1);
      if (hash === lastDrawerHash) return;
      lastDrawerHash = hash;

      var p = new DOMParser();
      var d = p.parseFromString(html, "text/html");
      var newOuter = d.querySelector("cart-drawer");
      var oldOuter = document.querySelector("cart-drawer");
      if (newOuter && oldOuter) {
        var preserveActive = oldOuter.classList.contains("active");
        oldOuter.className = newOuter.className;
        if (preserveActive) oldOuter.classList.add("active");
      }
      var n = d.querySelector("#CartDrawer") || newOuter;
      var o = document.querySelector("#CartDrawer") || oldOuter;
      if (!n || !o) return;

      var newInner = d.querySelector(".drawer__inner");
      var oldInner = document.querySelector(".drawer__inner");
      if (newInner && oldInner) {
        // in-place morph preserves scroll, node identity, and the live timer
        morphDrawer(oldInner, newInner);
      } else {
        captureScrollTop();
        o.innerHTML = n.innerHTML;
        requestAnimationFrame(function () { requestAnimationFrame(restoreScrollTop); });
        scheduleMerge(30);
      }
    } catch (e) { logErr("refreshDrawer err", e); }
  }

  function refreshBubble(sections) {
    if (!sections || !sections["cart-icon-bubble"]) return;
    try {
      document.querySelectorAll("#cart-icon-bubble, .cart-icon-bubble").forEach(function (b) {
        b.innerHTML = sections["cart-icon-bubble"];
      });
    } catch (_) {}
  }

  // =========================================================================
  // 4.5 Paid-line DOM merge — always show ONE paid row + ONE free row
  // =========================================================================
  // Shopify BxGy allocation sometimes splits the mat into paid + free + a
  // leftover paid line (exact-consumption ties, e.g. total 6). The cart DATA is
  // correct; only the display fragments. We merge paid rows visually.

  function computeMainMergePlan(items) {
    var paid = [], free = [];
    (items || []).forEach(function (i) {
      if (!isTierVariant(i.id)) return;
      (i.final_line_price > 0 ? paid : free).push(i);
    });
    var plan = { mergedQty: null, hideKeys: [], anchorKey: null, anchorQty: 0,
                 paidFinalCents: 0, paidQty: 0, freeHideKeys: [], freeAnchorKey: null, freeQty: 0 };
    plan.paidQty = paid.reduce(function (s2, i) { return s2 + i.quantity; }, 0);
    plan.freeQty = free.reduce(function (s2, i) { return s2 + i.quantity; }, 0);
    plan.paidFinalCents = paid.reduce(function (s2, i) { return s2 + i.final_line_price; }, 0);
    if (paid.length > 1) {
      plan.mergedQty = plan.paidQty;
      plan.anchorKey = paid[0].key;
      plan.anchorQty = paid[0].quantity;
      plan.hideKeys = paid.slice(1).map(function (i) { return i.key; });
    }
    if (free.length > 1) {
      plan.freeAnchorKey = free[0].key;
      plan.freeHideKeys = free.slice(1).map(function (i) { return i.key; });
    }
    return plan;
  }

  function moneyToCents(txt) {
    var m = String(txt || "").replace(/[^0-9.]/g, "");
    if (!m) return null;
    return Math.round(parseFloat(m) * 100);
  }
  function fmtCents(c) { return "$" + (c / 100).toFixed(2); }
  function fmtSave(c) {
    return (c % 100 === 0) ? "$" + (c / 100) : "$" + (c / 100).toFixed(2);
  }

  function mergeMainRowsInDom() {
    try {
      // 2026-09-05: the merge only exists to hide Shopify's BxGy paid/free split.
      // Products without BxGy free units must not be merged (it would fold two
      // different sizes into one row).
      if (!MERGE_ENABLED) { window.__gmMergedDisplayQty = null; return; }
      if (!cachedCart || !cachedCart.items) { window.__gmMergedDisplayQty = null; return; }
      var plan = computeMainMergePlan(cachedCart.items);
      window.__gmMergedDisplayQty = plan.mergedQty;
      if (plan.mergedQty == null && !plan.freeHideKeys.length) return;

      var rowFor = function (key) {
        return document.querySelector('tr.cart-item[data-line-key="' + key + '"], .cart-item[data-line-key="' + key + '"]');
      };
      plan.hideKeys.concat(plan.freeHideKeys).forEach(function (k) {
        var r = rowFor(k);
        if (r && r.style.display !== "none") r.style.display = "none";
      });
      if (plan.mergedQty != null && plan.anchorKey) {
        var row = rowFor(plan.anchorKey);
        if (!row) return;
        // IDEMPOTENCY (2026-07-19 fix): every write below must be a no-op when
        // values are unchanged, otherwise our own mutations re-trigger the
        // drawer MutationObserver and the per-unit derivation compounds
        // exponentially (the $5.4e19 old-price incident). Signature gate +
        // stamp-once per-unit + conditional writes.
        var sig = plan.paidQty + ":" + plan.paidFinalCents;
        if (row.getAttribute("data-gm-merge-sig") !== sig) {
          var input = row.querySelector("input.quantity__input, input[name='updates[]']");
          if (input && parseInt(input.value, 10) !== plan.mergedQty) {
            input.value = plan.mergedQty;
            input.setAttribute("value", plan.mergedQty);
            input.setAttribute("data-cart-quantity", plan.mergedQty);
          }
          // The theme's quantity-input froze the minus button based on the
          // anchor's REAL (split) qty = 1 = min; morph preserves that stale
          // disabled state so the button shows a not-allowed cursor even though
          // the merged qty is 4. Re-enable: the merged row is always above the
          // lowest tier and the engine intercepts the click to step tiers.
          var qbtns = row.querySelectorAll("quantity-input button, .quantity button, .quantity__button");
          for (var bi = 0; bi < qbtns.length; bi++) {
            var b = qbtns[bi];
            if (b.hasAttribute("disabled")) b.removeAttribute("disabled");
            if (b.getAttribute("aria-disabled") === "true") b.setAttribute("aria-disabled", "false");
            if (b.classList.contains("disabled")) b.classList.remove("disabled");
          }
          var oldEl = row.querySelector("s.cart-item__old-price");
          var finalEl = row.querySelector("strong.cart-item__final-price");
          var saveEl = row.querySelector(".gb-price-drawer-saving");
          if (oldEl && plan.anchorQty > 0) {
            var perUnit = parseInt(row.getAttribute("data-gm-per-unit-cents") || "", 10);
            if (isNaN(perUnit)) {
              var parsed = moneyToCents(oldEl.textContent);
              if (parsed != null) {
                perUnit = Math.round(parsed / plan.anchorQty);
                row.setAttribute("data-gm-per-unit-cents", String(perUnit));
              }
            }
            // sanity clamp: a $70 product's compare-at can never exceed $1000/unit
            if (!isNaN(perUnit) && perUnit > 0 && perUnit <= 100000) {
              var mergedOld = perUnit * plan.paidQty;
              if (oldEl.textContent !== fmtCents(mergedOld)) oldEl.textContent = fmtCents(mergedOld);
              if (saveEl) {
                var saveTxt = "Save " + fmtSave(mergedOld - plan.paidFinalCents);
                if (saveEl.textContent !== saveTxt) saveEl.textContent = saveTxt;
              }
            }
          }
          if (finalEl && finalEl.textContent !== fmtCents(plan.paidFinalCents)) {
            finalEl.textContent = fmtCents(plan.paidFinalCents);
          }
          row.setAttribute("data-gm-merge-sig", sig);
          log("dom-merge applied @ qty", plan.mergedQty, "sig", sig);
        }
      }
    } catch (e) { logErr("dom-merge err", e); }
  }

  var mergeTimer = null;
  function scheduleMerge(delay) {
    if (mergeTimer) clearTimeout(mergeTimer);
    mergeTimer = setTimeout(function () { mergeTimer = null; mergeMainRowsInDom(); }, delay == null ? 80 : delay);
  }


  // =========================================================================
  // 4.4 DOM morph — in-place reconcile instead of innerHTML/replaceChild.
  // Full-subtree replacement rebuilds every node: images reload, quantity
  // inputs blink, and the live countdown timer (whose <script> does not run
  // on innerHTML insert) freezes/flashes. morphElement updates only what
  // changed and preserves node identity, so nothing flickers. The timer
  // subtree is frozen (its own JS owns it). Validated: harness_morph.html.
  // =========================================================================
  function morphIsTimer(el){ return el && el.nodeType===1 && el.className && String(el.className).indexOf('cart-timer')!==-1; }
  function morphKeyOf(n){ return (n && n.nodeType===1 && n.getAttribute) ? (n.getAttribute('data-line-key')||null) : null; }
  function morphSyncAttrs(from,to){
    var ta=to.attributes,i,a;
    for(i=0;i<ta.length;i++){ a=ta[i]; if(from.getAttribute(a.name)!==a.value) from.setAttribute(a.name,a.value); }
    var fa=from.attributes;
    for(i=fa.length-1;i>=0;i--){ a=fa[i]; if(a.name.indexOf('data-gm-')===0) continue; if(!to.hasAttribute(a.name)) from.removeAttribute(a.name); }
  }
  function morphSyncProps(from,to){
    var tag=from.tagName;
    if(tag==='INPUT'||tag==='TEXTAREA'||tag==='SELECT'){
      var v=to.getAttribute('value'); if(v!=null && from.value!==v) from.value=v;
      if(from.type==='checkbox'||from.type==='radio'){ from.checked=to.hasAttribute('checked'); }
    }
  }
  function morphHasKeyedChild(el){ for(var c=el.firstElementChild;c;c=c.nextElementSibling){ if(c.getAttribute('data-line-key')) return true; } return false; }
  function morphText(from,to){ if(from.nodeValue!==to.nodeValue) from.nodeValue=to.nodeValue; }
  function morphIsBlank(n){ return n && n.nodeType===3 && !/\S/.test(n.nodeValue); }
  function morphPositional(from,to){
    var oc=from.firstChild, nc=to.firstChild;
    while(nc){
      if(morphIsBlank(nc)){ nc=nc.nextSibling; continue; }
      while(morphIsBlank(oc)) oc=oc.nextSibling;
      var nnext=nc.nextSibling;
      if(!oc){ from.appendChild(nc.cloneNode(true)); nc=nnext; continue; }
      var onext=oc.nextSibling;
      if(oc.nodeType!==nc.nodeType || (oc.nodeType===1 && oc.tagName!==nc.tagName)){ from.replaceChild(nc.cloneNode(true), oc); }
      else if(oc.nodeType===1){ morphElement(oc,nc); }
      else { morphText(oc,nc); }
      oc=onext; nc=nnext;
    }
    while(oc){ var d=oc; oc=oc.nextSibling; if(!morphIsBlank(d)) from.removeChild(d); }
  }
  function morphKeyed(from,to){
    var oldByKey={}, c;
    for(c=from.firstChild;c;c=c.nextSibling){ var k=morphKeyOf(c); if(k) oldByKey[k]=c; }
    var ordered=[], nc;
    for(nc=to.firstChild;nc;nc=nc.nextSibling){
      if(nc.nodeType!==1) continue;
      var nk=morphKeyOf(nc), ex=nk?oldByKey[nk]:null;
      if(ex){ morphElement(ex,nc); delete oldByKey[nk]; ordered.push(ex); }
      else { ordered.push(nc.cloneNode(true)); }
    }
    for(var kk in oldByKey){ var lo=oldByKey[kk]; if(lo.parentNode===from) from.removeChild(lo); }
    var rm=[]; for(c=from.firstChild;c;c=c.nextSibling){ if(c.nodeType===1 && ordered.indexOf(c)===-1) rm.push(c); }
    rm.forEach(function(n){ from.removeChild(n); });
    ordered.forEach(function(n){ from.appendChild(n); });
  }
  function morphElement(from,to){
    if(!from||!to||from.nodeType!==1||to.nodeType!==1) return;
    if(from.tagName!==to.tagName){ if(from.parentNode) from.parentNode.replaceChild(to.cloneNode(true),from); return; }
    if(morphIsTimer(from)) return;
    morphSyncAttrs(from,to); morphSyncProps(from,to);
    if(morphHasKeyedChild(to)) morphKeyed(from,to); else morphPositional(from,to);
  }
  // morph the drawer inner + re-apply the paid-line merge in the SAME frame
  // (no paint between), so the drawer never shows a fragmented intermediate.
  function morphDrawer(oldInner,newInner){
    try{ morphElement(oldInner,newInner); mergeMainRowsInDom(); }
    catch(e){ logErr("morphDrawer err",e); }
  }
  window.NorvynMorph={ morphElement: morphElement, morphDrawer: morphDrawer };

  function captureScrollTop() {
    try {
      var el = document.querySelector(SCROLL_SEL);
      if (el && el.scrollTop > 0) lastScrollTop = el.scrollTop;
    } catch (_) {}
  }
  function restoreScrollTop() {
    if (lastScrollTop <= 0) return;
    try {
      var el = document.querySelector(SCROLL_SEL);
      if (el) el.scrollTop = lastScrollTop;
    } catch (_) {}
  }

  // ===========================================================================
  // 5. Cleanup phase — enforce invariants
  // ===========================================================================
  // Invariants:
  //   • SP: 1 line at qty 1 (unless opted out)
  //   • main: totalMainQty === legalQ (qFromN(nFromQ(totalQ)))
  //   • gifts: exactly the set giftIdsForN(N), each at qty 1 (or 0 if no tier matches)
  //
  // Shopify BxGy auto-split is PRESERVED at any line count when totalQ === legalQ.
  // ===========================================================================

  async function cleanupCart(reason) {
    if (cleanupRunning) {
      cleanupQueuedReason = reason || cleanupQueuedReason || "queued";
      return;
    }
    if (internalMutation > 0) {
      scheduleCleanup(reason || "busy", 150);
      return;
    }
    cleanupRunning = true;
    try {
      var pass = 0;
      var passReason = reason || cleanupQueuedReason || "cleanup";
      cleanupQueuedReason = null;
      while (pass < CFG.maxCleanupPasses) {
        var changed = await cleanupPass(passReason);
        pass++;
        if (!changed && !cleanupQueuedReason) break;
        if (cleanupQueuedReason) {
          passReason = cleanupQueuedReason;
          cleanupQueuedReason = null;
        }
      }
      if (pass >= CFG.maxCleanupPasses) {
        log("cleanup max passes reached", passReason, "— retry in", CFG.maxPassRetryMs, "ms");
        setTimeout(function () { scheduleCleanup("max-pass-retry", 0); }, CFG.maxPassRetryMs);
      }
      setTimeout(verifyGiftsInvariant, CFG.verifyGiftsDelayMs);
    } catch (e) { logErr("cleanup err", e); }
    finally {
      cleanupRunning = false;
      if (cleanupQueuedReason || internalMutation > 0) {
        var nextReason = cleanupQueuedReason || "after-internal";
        cleanupQueuedReason = null;
        scheduleCleanup(nextReason, 150);
      }
    }
  }

  async function cleanupPass(reason) {
    try {
      var cart = await getCart();
      var updates = {};
      var addsNeeded = [];

      reconcileSP(cart, updates);
      reconcileMain(cart, updates);
      reconcileGifts(cart, updates, addsNeeded);

      var changed = false;
      if (Object.keys(updates).length) {
        log("cleanup", reason, "updates", JSON.stringify(updates));
        changed = !!(await updateCart(updates)) || changed;
      }
      if (addsNeeded.length) {
        log("cleanup add gifts", addsNeeded.length, "ids=",
            addsNeeded.map(function (a) { return a.id; }).join(","));
        var addResult = await addItems(addsNeeded);
        changed = true;
        if (addResult === null) log("cleanup add gifts FAILED — will retry");
      }
      if (rebuildTargetQ != null) {
        var target = rebuildTargetQ;
        rebuildTargetQ = null;
        log("rebuild main lines @ qty", target);
        await rebuildMainLines(target);
        changed = true;
      }
      return changed;
    } catch (e) { logErr("cleanupPass err", e); return false; }
  }

  function reconcileSP(cart, updates) {
    if (!SP_VARIANT) return;
    var spLines = (cart.items || []).filter(function (i) { return String(i.id) === SP_VARIANT; });
    if (isSpOptedOut()) {
      spLines.forEach(function (i) { updates[i.key] = 0; });
    } else if (spLines.length > 1) {
      spLines.slice(1).forEach(function (i) { updates[i.key] = 0; });
      if (spLines[0].quantity !== 1) updates[spLines[0].key] = 1;
    } else if (spLines.length === 1 && spLines[0].quantity !== 1) {
      updates[spLines[0].key] = 1;
    }
  }

  function reconcileMain(cart, updates) {
    // TIER-STEP MODE (2026-07-19 FINAL, per Eric): drawer +/- moves between the
    // 3 advertised bundle tiers - Buy1 = 1 unit, Buy2Get1 = 3 units (2 paid + 1
    // free), Buy3Get2 = 5 units (3 paid + 2 free), capped at 5. This reconciler:
    //   (a) cascade-removes SP when the mat leaves the cart,
    //   (b) snaps any drifted total to the nearest legal tier quantity,
    //   (c) defragments multiple PAID lines so the drawer always shows one paid
    //       line + the native free allocation line.
    var mLines = mainLines(cart);
    var totalQ = totalMainQty(cart);
    var N      = nFromQ(totalQ);
    var legalQ = qFromN(N);

    if (liveLines(cart).length === 0) {
      // No live product of any kind left: cascade SP and linked gifts away.
      (cart.items || []).forEach(function (i) {
        if ((SP_VARIANT && String(i.id) === SP_VARIANT) || isLinkedGift(i)) updates[i.key] = 0;
      });
      return;
    }
    if (mLines.length === 0) return; // other live product only (e.g. sleeves): nothing to tier
    var paidLines = mLines.filter(function (l) { return l.final_line_price > 0; });
    if (mLines.length === 1) {
      if (mLines[0].quantity !== legalQ) {
        updates[mLines[0].key] = legalQ;
        log("snap qty", mLines[0].quantity, "→", legalQ);
      }
      return;
    }
    if (totalQ === legalQ) {
      // Legal total. Shopify's discount pick at some totals (e.g. 6: B2G1x2 vs
      // B3G2, equal value) is nondeterministic and can leave a leftover paid
      // line = 3-line display. Rebuilding just re-rolls the same dice, so we do
      // NOT rebuild here - the DOM merge (mergeMainRowsInDom) presents all paid
      // lines as one row instead. Data stays correct either way.
      return;
    }
    // Illegal total (drift) → rebuild to legalQ. Converges by definition:
    // after the rebuild the total IS legal, so this never re-triggers.
    rebuildTargetQ = legalQ;
    log("flag rebuild:", mLines.length, "lines, totalQ", totalQ, "→", legalQ);
  }

  async function rebuildMainLines(target) {
    for (var guard = 0; guard < 8; guard++) {
      var cart = await getCart();
      var mats = mainLines(cart);
      if (!mats.length) break;
      internalMutation++;
      try {
        await origFetch("/cart/change.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: mats[0].key, quantity: 0 })
        });
      } catch (e) { logErr("rebuild zero err", e); break; }
      finally { internalMutation = Math.max(0, internalMutation - 1); }
    }
    if (target > 0) {
      await addItems([{ id: parseInt(MAIN_VARIANT, 10), quantity: target }]);
    }
    cachedCart = null;
    try { await getCart(); } catch (_) {}
  }

  // Multi-tier-aware gift reconciliation.
  // Uses giftIdsForN(N) which returns the expected gift set for the current N
  // based on giftStrategy ("replace" or "additive").
  function reconcileGifts(cart, updates, addsNeeded) {
    var totalQ = totalMainQty(cart);
    var N      = nFromQ(totalQ);
    var expectedIds = giftIdsForN(N);     // What SHOULD be in cart
    var expectedSet = {};
    expectedIds.forEach(function (id) { expectedSet[String(id)] = true; });

    var giftLines = (cart.items || []).filter(isLinkedGift);
    var presentSet = {};

    // Pass 1: dedup gifts that are expected; remove gifts that are NOT expected
    giftLines.forEach(function (line) {
      var vid = String(line.id);
      if (!expectedSet[vid]) {
        // Gift not expected at this N — remove
        updates[line.key] = 0;
        return;
      }
      if (presentSet[vid]) {
        // Duplicate of an expected gift — remove the dupe
        updates[line.key] = 0;
        return;
      }
      // First occurrence of an expected gift — keep, normalize qty=1
      presentSet[vid] = true;
      if (line.quantity !== 1) updates[line.key] = 1;
    });

    // Pass 2: add any expected gift that's missing
    expectedIds.forEach(function (id) {
      if (!presentSet[id]) {
        addsNeeded.push({
          id: parseInt(id, 10),
          quantity: 1,
          properties: { _is_free_gift: "true", _linked_to_product: MAIN_PRODUCT_ID }
        });
      }
    });
  }

  // Defense in depth — 1.5s after cleanup, verify gift invariant.
  // Catches silent addItems failures.
  async function verifyGiftsInvariant() {
    try {
      var r = await origFetch("/cart.js", { credentials: "same-origin" });
      var cart = await r.json();
      var N = nFromQ(totalMainQty(cart));
      var expectedIds = giftIdsForN(N);

      var present = {};
      (cart.items || []).forEach(function (i) {
        if (isLinkedGift(i) && i.quantity >= 1) present[String(i.id)] = true;
      });
      var missing = expectedIds.filter(function (id) { return !present[id]; });

      if (missing.length > 0) {
        log("VERIFY: gifts missing at N=", N, "expected=", expectedIds.length,
            "missing=", missing.length, "— scheduling cleanup");
        scheduleCleanup("gift-verify-retry", 0);
      }
    } catch (e) { logErr("verify err", e); }
  }

  function scheduleCleanup(reason, delay) {
    cleanupQueuedReason = reason || cleanupQueuedReason || "scheduled";
    if (cleanupRunning) return;
    if (cleanupTimer) clearTimeout(cleanupTimer);
    cleanupTimer = setTimeout(function () {
      cleanupTimer = null;
      var q = cleanupQueuedReason || reason;
      cleanupQueuedReason = null;
      cleanupCart(q);
    }, delay == null ? CFG.cleanupDebounceMs : delay);
  }

  // ===========================================================================
  // 6. Snap — rewrite body on /cart/change & /cart/update
  // ===========================================================================

  function findLineFromChangeBody(cart, body) {
    var items = (cart && cart.items) || [];
    if (body && body.line != null) {
      var idx = parseInt(body.line, 10) - 1;
      return (idx >= 0 && idx < items.length) ? items[idx] : null;
    }
    if (body && body.id != null) {
      return items.find(function (it) {
        return String(it.key) === String(body.id) || String(it.id) === String(body.id);
      }) || null;
    }
    return null;
  }

  function findLineFromUpdateKey(cart, key) {
    var items = (cart && cart.items) || [];
    return items.find(function (it) { return String(it.key) === String(key); })
        || items.find(function (it) { return String(it.id)  === String(key); })
        || null;
  }

  function snapRequestedQty(currentLineQ, requestedLineQ, totalNow, displayQ) {
    var baseline = (displayQ != null) ? displayQ : currentLineQ;
    var direction =
      requestedLineQ > baseline ?  1 :
      requestedLineQ < baseline ? -1 : 0;
    var currentN  = nFromQ(totalNow);
    var newN      = Math.max(0, currentN + direction);
    var newTotalQ = qFromN(newN);
    var newLineQ  = Math.max(0, currentLineQ + (newTotalQ - totalNow));
    return { direction: direction, currentN: currentN, newN: newN, newTotalQ: newTotalQ, newLineQ: newLineQ };
  }

  function serializeSnap(fn) {
    var next = snapMutex.then(fn, fn);
    snapMutex = next.then(function () {}, function () {});
    return next;
  }

  function handleCartChange(input, init) {
    return serializeSnap(async function () {
      try {
        var body = typeof init.body === "string" ? JSON.parse(init.body) : init.body;
        var changedBody = false;

        // Path 1: /cart/change body.line OR body.id
        if (body && body.quantity != null && (body.id != null || body.line != null)) {
          var cart = await ensureCartFresh();
          if (cart) {
            var line = findLineFromChangeBody(cart, body);
            if (line && SP_VARIANT && String(line.id) === SP_VARIANT && parseInt(body.quantity, 10) === 0) {
              setSpOptedOut(true);
              log("SP opt-out (removed via change)");
            }
            if (line && isTierVariant(line.id)) {
              var totalNow = totalMainQty(cart);
              var requestedLineQ = parseInt(body.quantity, 10);
              if (!isNaN(requestedLineQ)) {
                var displayQ = (line.final_line_price > 0 && window.__gmMergedDisplayQty != null)
                  ? window.__gmMergedDisplayQty : null;
                var snap = snapRequestedQty(line.quantity, requestedLineQ, totalNow, displayQ);
                if (snap.newLineQ !== requestedLineQ) {
                  body.quantity = snap.newLineQ;
                  changedBody = true;
                  log("tier-step", line.quantity, "→", snap.newLineQ,
                      "(totalQ", totalNow, "→", snap.newTotalQ,
                       ", tier", snap.currentN, "→", snap.newN, ")");
                }
              }
            }
          }
        }

        // Path 2: /cart/update body.updates = {key: qty}
        if (body && body.updates && typeof body.updates === "object") {
          var cart2 = await ensureCartFresh();
          if (cart2) {
            var workingTotalQ = totalMainQty(cart2);
            var workingLineQty = {};
            (cart2.items || []).forEach(function (it) { workingLineQty[it.key] = it.quantity; });
            Object.keys(body.updates).forEach(function (key) {
              var line2 = findLineFromUpdateKey(cart2, key);
              if (line2 && SP_VARIANT && String(line2.id) === SP_VARIANT && parseInt(body.updates[key], 10) === 0) {
                setSpOptedOut(true);
                log("SP opt-out (removed via update)");
              }
              if (!line2 || !isTierVariant(line2.id)) return;
              var requestedLineQ2 = parseInt(body.updates[key], 10);
              if (isNaN(requestedLineQ2)) return;
              var currentLineQ = workingLineQty[line2.key] != null ? workingLineQty[line2.key] : line2.quantity;
              var snap2 = snapRequestedQty(currentLineQ, requestedLineQ2, workingTotalQ);
              if (snap2.newLineQ !== requestedLineQ2) {
                body.updates[key] = snap2.newLineQ;
                changedBody = true;
                log("tier-step update", currentLineQ, "→", snap2.newLineQ);
              }
              workingTotalQ = snap2.newTotalQ;
              workingLineQty[line2.key] = snap2.newLineQ;
            });
          }
        }

        if (changedBody) init = Object.assign({}, init, { body: JSON.stringify(body) });
      } catch (e) { logErr("snap err", e); }

      var p = origFetch(input, init);
      try {
        var r = await p;
        if (r && r.ok) {
          try {
            var d = await r.clone().json();
            cachedCart = (d && d.items) ? d : null;
          } catch (_) { cachedCart = null; }
          scheduleCleanup("after-update", CFG.cleanupDebounceMs);
          scheduleMerge(150);
        }
      } catch (_) {}
      return p;
    });
  }

  // ===========================================================================
  // 7. Fetch interceptor
  // ===========================================================================

  window.fetch = function (input, init) {
    var url    = typeof input === "string" ? input : (input && input.url) || "";
    var method = String((init && init.method) || "GET").toUpperCase();

    if (internalMutation === 0 && method === "POST" && init && init.body &&
        (url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1)) {
      return handleCartChange(input, init);
    }

    var p = origFetch.apply(this, arguments);

    if (internalMutation === 0 && method === "POST") {
      if (url.indexOf("/cart/add") !== -1) {
        try {
          var b = init && init.body;
          var addedSp = false;
          if (SP_VARIANT && b) {
            if (typeof b === "string" && b.indexOf(SP_VARIANT) !== -1) addedSp = true;
            else if (typeof FormData !== "undefined" && b instanceof FormData) {
              var fdid = b.get && b.get("id");
              if (String(fdid) === SP_VARIANT) addedSp = true;
              if (!addedSp && b.entries) {
                for (var pr of b.entries()) {
                  if (/^items\[\d+\]\[id\]$/.test(pr[0]) && String(pr[1]) === SP_VARIANT) { addedSp = true; break; }
                }
              }
            }
          }
          if (addedSp) {
            setSpOptedOut(false);
            log("SP opt-out reset (toggle on)");
          }
        } catch (_) {}
        p.then(function (r) {
          if (!r || !r.ok) return;
          origFetch("/cart.js", { credentials: "same-origin" })
            .then(function (r2) { return r2.json(); })
            .then(function (d) {
              cachedCart = d;
              scheduleCleanup("after-add", 0);
              scheduleMerge(150);
            })
            .catch(function () {
              cachedCart = null;
              scheduleCleanup("after-add", 100);
            });
          if (SP_VARIANT) setTimeout(function () { maybeAddSP().catch(function () {}); }, 500);
          setTimeout(function () { scheduleCleanup("after-add-fallback", 0); }, CFG.postAddFallbackMs);
        }).catch(function () {});
      } else if (url.indexOf("/cart/clear") !== -1) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          cachedCart = null;
          setTimeout(getCart, 200);
        }).catch(function () {});
      }
    }
    return p;
  };

  // ===========================================================================
  // 8. Trash override
  // ===========================================================================

  document.addEventListener("click", async function (e) {
    var rb = e.target && e.target.closest && e.target.closest("cart-remove-button, .cart-remove-button");
    if (!rb) return;
    var row = e.target.closest("tr.cart-item, .cart-item");
    if (!row) return;

    var rowVid = row.getAttribute("data-variant-id");
    if (row.getAttribute("data-free-gift") === "true" ||
        row.classList.contains("cart-item--free-gift") ||
        ALL_GIFT_IDS.indexOf(String(rowVid)) !== -1) {
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }

    var variantId = rb.dataset.id || rowVid;
    if (!variantId) return;
    var rowKey = row.getAttribute("data-line-key");

    e.preventDefault(); e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    try {
      var cart = await getCart();
      var updates = {};
      if (isMainVariant(variantId)) {
        // Remove every line of the trashed variant; cascade SP and gifts only when no
        // other main variant is left (single-variant products: always, as before).
        var otherMainLeft = (cart.items || []).some(function (i) {
          return isMainVariant(i.id) && String(i.id) !== String(variantId);
        });
        (cart.items || []).forEach(function (i) {
          if (String(i.id) === String(variantId) ||
              (!otherMainLeft && ((SP_VARIANT && String(i.id) === SP_VARIANT) ||
              isLinkedGift(i)))) updates[i.key] = 0;
        });
      } else if (SP_VARIANT && String(variantId) === SP_VARIANT) {
        (cart.items || []).filter(function (i) { return String(i.id) === SP_VARIANT; })
          .forEach(function (i) { updates[i.key] = 0; });
        setSpOptedOut(true);
      } else {
        // The clicked row by its line key first: two lines can share a variant (different properties).
        var clicked = (cart.items || []).find(function (i) { return rowKey && i.key === rowKey; }) ||
                      (cart.items || []).find(function (i) { return String(i.id) === String(variantId); });
        if (!clicked) { if (onCartPage()) location.reload(); return; }  // stale page: show the server cart
        updates[clicked.key] = 0;
      }
      // PDP add-ons follow their parent out (GM_ADDON_PROPERTY + GM_ADDON_PARENT_VARIANTS).
      if (ADDON_PROP && ADDON_PARENTS.length) {
        var parentLeft = (cart.items || []).some(function (i) {
          return ADDON_PARENTS.indexOf(String(i.id)) !== -1 && updates[i.key] !== 0;
        });
        if (!parentLeft) (cart.items || []).forEach(function (i) {
          if (i.properties && i.properties[ADDON_PROP]) updates[i.key] = 0;
        });
      }
      log("trash", variantId, "→", Object.keys(updates).length, "lines");
      await updateCart(updates);
      // updateCart re-renders only the drawer and the bubble; on /cart the removed row would stay and the
      // next click would find nothing (2026-10-10, same bug Eric hit on Elouria: "购物车无法删除").
      if (onCartPage()) location.reload();
    } catch (err) { logErr("trash err", err); }
  }, true);

  // ===========================================================================
  // 9. CSS injection
  // ===========================================================================

  function injectCss() {
    if (document.getElementById("gm-css")) return;
    var s = document.createElement("style");
    s.id = "gm-css";
    s.textContent =
      ".cart-item--free-gift .quantity-popover-container," +
      ".cart-item--free-gift cart-remove-button," +
      ".cart-item--free-gift .cart-remove-button," +
      "[data-free-gift='true'] .quantity-popover-container," +
      "[data-free-gift='true'] cart-remove-button," +
      "[data-free-gift='true'] .cart-remove-button" +
      "{display:none!important;visibility:hidden!important;pointer-events:none!important}" +
      // Suppress the theme's stock-style quantity error toast. Inventory is
      // untracked on this store, so the ONLY thing that can trigger it is the
      // tier cap snapping a + click back down - and "You can only add N" reads
      // like a stock problem to the customer. Hide it entirely.
      "[id^='CartDrawer-LineItemError'],[id^='Line-item-error'],.cart-item__error{display:none!important}" +
      "cart-drawer-items,#CartDrawer-CartItems{-webkit-overflow-scrolling:touch}";
    document.head.appendChild(s);
  }

  // ===========================================================================
  // 10. Scroll guard (theme cart:ajax-update path)
  // ===========================================================================

  function installScrollGuard() {
    try {
      var drawer = document.querySelector("cart-drawer");
      if (!drawer || drawer.__gmScrollGuard) return;
      drawer.__gmScrollGuard = true;

      function bindScroll() {
        var el = drawer.querySelector(SCROLL_SEL);
        if (!el || el.__gmScrollBound) return;
        el.__gmScrollBound = true;
        el.addEventListener("scroll", function () {
          if (el.scrollTop > 0) lastScrollTop = el.scrollTop;
        }, { passive: true });
      }
      bindScroll();

      new MutationObserver(function () {
        bindScroll();
        scheduleMerge();
        if (lastScrollTop > 0) {
          requestAnimationFrame(function () { requestAnimationFrame(restoreScrollTop); });
        }
      }).observe(drawer, { childList: true, subtree: true });
    } catch (e) { logErr("scrollGuard err", e); }
  }

  // ===========================================================================
  // 11. Boot
  // ===========================================================================

  function boot() {
    injectCss();
    installScrollGuard();
    setTimeout(installScrollGuard, 2000);
    setTimeout(function () {
      getCart().then(function () { cleanupCart("boot"); scheduleMerge(120); });
    }, 800);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
